
import constants from './constants'

const utilities = {
  // returns the actual value if it exists, otherwise the masked value
  unmaskField(fieldActual, fieldMasked) {
    if (fieldActual) {
      return fieldActual;
    }
    return fieldMasked;
  },

  maskCvv(cvvActual, cvvMasked) {      // call this on "Blur" (i.e., on "Lost focus")
    let newActual = cvvActual;
    let newMasked = cvvMasked;
    if (cvvMasked && !cvvMasked.startsWith(constants.starChar)) {
      newActual = cvvMasked;
      const len = cvvMasked.length;
      newMasked = constants.star4Char.substring(0, len);
    } else if (!cvvMasked) {
      newActual = '';
    }
    return [newActual, newMasked];
  },

  maskCreditCard(numberActual, numberMasked) {      // call this on "Blur" (i.e., on "Lost focus")
    let newActual = numberActual;
    let newMasked = numberMasked;
    if (numberMasked && !numberMasked.startsWith(constants.starChar)) {
      newActual = numberMasked;
      const len = numberMasked.length;
      switch (len) {
        case 16:
          newMasked = `${constants.star4Char} ${constants.star4Char} ${constants.star4Char} ${newActual.substring(12, len)}`;
          break;
        case 15:
          newMasked = `${constants.star4Char} ${constants.star6Char} ${constants.starChar} ${newActual.substring(11, len)}`;
          break;
        default:
          newMasked = `${constants.starChar.repeat(11).substring(0, len - 4)} ${newActual.substring(len - 4, len)}`;
          break;
      }
    } else if (!numberMasked) {
      newActual = '';
    }
    return [newActual, newMasked];
  },

  loadExpiryMonths() {
    return [
      { value: '01', text: '01-January' },
      { value: '02', text: '02-February' },
      { value: '03', text: '03-March' },
      { value: '04', text: '04-April' },
      { value: '05', text: '05-May' },
      { value: '06', text: '06-June' },
      { value: '07', text: '07-July' },
      { value: '08', text: '08-August' },
      { value: '09', text: '09-September' },
      { value: '10', text: '10-October' },
      { value: '11', text: '11-November' },
      { value: '12', text: '12-December' },
    ];
  },

  loadExpiryYears() {
    const yearStart = new Date().getFullYear();
    const yearEnd = yearStart + 15;
    const years = [];

    for (let i = yearStart; i < yearEnd; i++) {
      years.push({ value: i, text: i.toString() });
    }

    return years;
  },

  loadStates() {
    return [
      { value: 'AL', text: 'Alabama' },
      { value: 'AK', text: 'Alaska' },
      { value: 'AZ', text: 'Arizona' },
      { value: 'AR', text: 'Arkansas' },
      { value: 'CA', text: 'California' },
      { value: 'CO', text: 'Colorado' },
      { value: 'CT', text: 'Connecticut' },
      { value: 'DE', text: 'Delaware' },
      { value: 'FL', text: 'Florida' },
      { value: 'GA', text: 'Georgia' },
      { value: 'HI', text: 'Hawaii' },
      { value: 'ID', text: 'Idaho' },
      { value: 'IL', text: 'Illinois' },
      { value: 'IN', text: 'Indiana' },
      { value: 'IA', text: 'Iowa' },
      { value: 'KS', text: 'Kansas' },
      { value: 'KY', text: 'Kentucky' },
      { value: 'LA', text: 'Louisiana' },
      { value: 'ME', text: 'Maine' },
      { value: 'MD', text: 'Maryland' },
      { value: 'MA', text: 'Massachusetts' },
      { value: 'MI', text: 'Michigan' },
      { value: 'MN', text: 'Minnesota' },
      { value: 'MS', text: 'Mississippi' },
      { value: 'MO', text: 'Missouri' },
      { value: 'MT', text: 'Montana' },
      { value: 'NE', text: 'Nebraska' },
      { value: 'NV', text: 'Nevada' },
      { value: 'NH', text: 'New Hampshire' },
      { value: 'NJ', text: 'New Jersey' },
      { value: 'NM', text: 'New Mexico' },
      { value: 'NY', text: 'New York' },
      { value: 'NC', text: 'North Carolina' },
      { value: 'ND', text: 'North Dakota' },
      { value: 'OH', text: 'Ohio' },
      { value: 'OK', text: 'Oklahoma' },
      { value: 'OR', text: 'Oregon' },
      { value: 'PA', text: 'Pennsylvania' },
      { value: 'RI', text: 'Rhode Island' },
      { value: 'SC', text: 'South Carolina' },
      { value: 'SD', text: 'South Dakota' },
      { value: 'TN', text: 'Tennessee' },
      { value: 'TX', text: 'Texas' },
      { value: 'UT', text: 'Utah' },
      { value: 'VT', text: 'Vermont' },
      { value: 'VA', text: 'Virginia' },
      { value: 'WA', text: 'Washington' },
      { value: 'WV', text: 'West Virginia' },
      { value: 'WI', text: 'Wisconsin' },
      { value: 'WY', text: 'Wyoming' },
      { value: 'AS', text: 'American Samoa' },
      { value: 'DC', text: 'District of Columbia' },
      { value: 'FM', text: 'Federated States of Micronesia' },
      { value: 'GU', text: 'Guam' },
      { value: 'MH', text: 'Marshall Islands' },
      { value: 'MP', text: 'Northern Mariana Islands' },
      { value: 'PW', text: 'Palau' },
      { value: 'PR', text: 'Puerto Rico' },
      { value: 'VI', text: 'Virgin Islands' },
      { value: 'OT', test: 'Other' },
    ];
  },

  // Returns a 5-digit zip code from either a 9 character (555554444) or 10 character (55555-4444) zip code
  stripZipPlusFour(zipCodeString) {
    if ((zipCodeString.length === 10 && zipCodeString.includes('-')) || zipCodeString.length === 9) {
      return zipCodeString.substring(0, 5);
    }
    // otherwise
    return zipCodeString;
  },

  capitalizeFirstLetter(someString) {
    return someString[0].toUpperCase() + someString.slice(1).toLowerCase();
  },

  returnToAmbitCares() {
    const prodUrl = 'http://www.ambitcares.org';
    const intUrl = 'http://int.ambitcares.org';
    
    const domain = document.location.hostname;
    if (domain.includes('localhost') || domain.includes('int')) {
      window.location.href = intUrl;
    } else {
      window.location.href = prodUrl;
    }
  },

}

export default utilities
